<template>
  <section class="plugins">

    <div class="plugins__container container">

      <div class="plugins__title">

        <h2 class="plugins__title--h2">
          Plugins
        </h2>

        <p class="plugins__title--p">
          para aumentar la productividad
        </p>

      </div>

      <div id="modulos" class="modulos plugins__slider">

        <div class="modulos__current">
          <div class="modulos__info">
            <h2 class="modulos__info--h2">
              {{ selectedItem.name }}
            </h2>
            <p class="modulos__info--p">
              {{ selectedItem.short_descript }}
            </p>
            <RouterLink class="modulos__info--a" :to="{ name: 'plugins', params: { id: selectedItem.id } }">
              <span>{{ selectedItem.price }} UF/Mes</span>
              <i class="ri-arrow-right-up-line"></i>
            </RouterLink>
          </div>

          <div class="modulos__arrows">
            <button @click="decrementIndex" class="modulos__arrows--left modulos__arrows--button">
              <i class="ri-arrow-left-s-line"></i>
            </button>
            <button @click="incrementIndex" class="modulos__arrows--right modulos__arrows--button">
              <i class="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div class="modulos__featured">
          <div class="modulos__featured--box">
            <img class="modulos__featured--img" :src="'assets/img/plugins/' + selectedItem.image"
              alt="featured image slider">
          </div>
        </div>

        <TransitionGroup name="plugin-carousel" tag="div" class="modulos__slider">
          <div v-for="(plugin, index) in plugins" :key="plugin.id"
            :class="['modulos__item', (index === selectedIndex) ? 'modulos__item--active' : '']"
            @click="getItemByIndex(index)">

            <div class="modulos__container">
              <div class="modulos__info">
                <h3 class="modulos__title">
                  {{ plugin.name }}
                </h3>
              </div>
              <div class="modulos__featured--item">
                <img class="modulos__img--item" :src="'assets/img/plugins/' + plugin.image"
                  alt="featured imagen item slider">
              </div>
            </div>
          </div>
        </TransitionGroup>

      </div>
    </div>

  </section>
</template>

<script lang="ts" setup>
import Plugins from '@/entities/Plugins';
import PluginsService from '@/services/PluginsService';
import { computed, onMounted, ref, Ref } from 'vue';

const pluginsService: Ref<PluginsService> = ref(new PluginsService())
const plugins: Ref<Plugins[]> = ref([])
let selectedIndex: Ref<number> = ref(0)
const isMounted = ref(false)

onMounted(async () => {
  await getPlugins()
  getItemByIndex(0)
  isMounted.value = true
})

const getPlugins = async () => {
  plugins.value = await pluginsService.value.getFilteredPlugins(false)
}

const getItemByIndex = (index: number): Plugins | undefined => {
  if (index >= 0 && index < plugins.value.length) {
    // Reorganizar el array para que el item clickeado quede al inicio
    const clickedPlugin = plugins.value[index]
    const beforeClicked = plugins.value.slice(0, index)
    const afterClicked = plugins.value.slice(index + 1)
    
    // Nuevo orden: item clickeado al inicio, luego los que estaban después, luego los que estaban antes
    plugins.value = [clickedPlugin, ...afterClicked, ...beforeClicked]
    
    // El índice seleccionado ahora es siempre 0 (el primero)
    selectedIndex.value = 0
    
    // Hacer scroll al inicio del slider
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
    
    return plugins.value[0]
  }
  return undefined
}

const selectedItem = computed((): Plugins => {
  if (isMounted.value && plugins.value.length > 0) {
    return plugins.value[selectedIndex.value]
  }
  return {} as Plugins
})

const incrementIndex = () => {
  if (plugins.value.length > 0) {
    // Mover el primer elemento al final
    const firstPlugin = plugins.value[0]
    plugins.value = [...plugins.value.slice(1), firstPlugin]
    
    // El índice siempre es 0
    selectedIndex.value = 0
    
    // Hacer scroll al inicio
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
  }
};

const decrementIndex = () => {
  if (plugins.value.length > 0) {
    // Mover el último elemento al inicio
    const lastPlugin = plugins.value[plugins.value.length - 1]
    plugins.value = [lastPlugin, ...plugins.value.slice(0, -1)]
    
    // El índice siempre es 0
    selectedIndex.value = 0
    
    // Hacer scroll al inicio
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
  }
};

</script>

<style scoped>
/* Animaciones para el carrusel de plugins */
.plugin-carousel-move {
  transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);
}

.plugin-carousel-enter-active {
  transition: all 0.4s cubic-bezier(0.55, 0, 0.1, 1);
}

.plugin-carousel-leave-active {
  transition: all 0.4s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
}

.plugin-carousel-enter-from {
  opacity: 0;
  transform: translateX(30px) scale(0.95);
}

.plugin-carousel-leave-to {
  opacity: 0;
  transform: translateX(-30px) scale(0.95);
}

/* Asegurar que los elementos en movimiento tengan z-index apropiado */
.modulos__item {
  transition: all 0.3s ease;
}
</style>
